import script from "./TalkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TalkCard.vue?vue&type=script&setup=true&lang=js"

import "./TalkCard.vue?vue&type=style&index=0&id=1797a0c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1797a0c1"]])

export default __exports__